module.exports = __webpack_public_path__ + "static/img/cabinet24_6.62dac545.gif";